import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.css'
import './app.css'

import { Header } from '../authenticated/header/header'
import AppSidebar from '../authenticated/header/appSidebar'
import Footer from '../components/footer'
import { RoleConstant } from './roleConstant'
import { Flex11Div, FlexColumnDiv } from '../authenticated/components/components'
import { AuthenticationService } from './authenticationService'
import { HistoryService } from './historyService'
import { LoggedUserService } from '../authenticated/loggedUser/loggedUserService'

import RegisterUserPage from '../anonymous/registerUser/registerUserPage'
import LandpagePage from '../anonymous/landpage/login2'
import PasswordResetPage from '../anonymous/passwordReset/passwordResetPage'
import ActiveEnvironmentPage from '../anonymous/activeEnvironment/activeEnvironmentPage'
import PrivacyPolicyPage from '../anonymous/privacyPolicy/privacyPolicyPage'
import PlanPage from '../anonymous/planPage/planPage'
import EquipmentsPage from '../authenticated/equipment/equipmentsPage'
import MaintenancesPage from '../authenticated/maintenance/maintenancePage'
import CategoriesPage from '../authenticated/category/categoriesPage'
import InspectionTypesPage from '../authenticated/inspectionType/inspectionTypesPage'
import ProductsPage from '../authenticated/product/productsPage'
import TagsPage from '../authenticated/tag/tagsPage'
import TagsReplacePage from '../authenticated/tag/tagsReplacePage'
import CompanyUsersPage from '../authenticated/companyUser/companyUsersPage'
import UserCompanyGroupPage from '../authenticated/userCompanyGroup/userCompanyGroupPage'
import CompaniesPage from '../authenticated/company/companiesPage'
import CompanyGroupsPage from '../authenticated/companyGroup/companyGroupsPage'
import LoggedUserPage from '../authenticated/loggedUser/loggedUserPage'
import { CompanyGroupService } from '../authenticated/companyGroup/companyGroupService'
import ChangePasswordPage from '../authenticated/loggedUser/changePasswordPage'
import UsersPage from '../authenticated/user/usersPage'
import OsPage from '../authenticated/os/osPage'
import { DashboardCommonPage } from '../authenticated/dashboard/dashboardCommonPage'
import { DashboardPage } from '../authenticated/dashboard/dashboardPage'
import ConfigSystemPage from '../authenticated/configuration/configSystemPage'
import { RedirectPage } from './redirectPage'
import languages from "../translations"
import { CompanyGroupStatus } from '../authenticated/companyGroup/companyGroupStatus'
import MyPlanPage from '../authenticated/myPlan/myPlanPage'
import BuyTagPage from '../authenticated/myPlan/buyTagPage'
import VideoLessonsPage from '../authenticated/videoLessons/videoLessonsPage'
import TagQrCodePage from '../authenticated/tag/tagQrCodePage'

import LoadingScreen from 'react-loading-screen'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import LOGO from '../anonymous/landpage/images/logo-white.png'

import ReactGA from 'react-ga'
import CreateOSPage from '../authenticated/os/createOSPage';
import ClientHomePage from "../authenticated/bepiService/client/clientHome/clientHomePage";
// import ClientEquipamentsPage from "../authenticated/bepiService/client/clientEquipaments/clientEquipamentsPage";
import ClientQuotationsPage from "../authenticated/bepiService/client/clientQuotations/clientQuotationsPage";
import ClientQuotePage from "../authenticated/bepiService/client/clientQuote/clientQuotePage";
import ClientEquipamentDetailsPage from "../authenticated/bepiService/client/clientEquipamentDetails/clientEquipamentDetailsPage";
import ClientQuoteDetailsPage from "../authenticated/bepiService/client/clientQuoteDetails/clientQuoteDetailsPage";
import ClientShipmentInstructionsPage
    from "../authenticated/bepiService/client/clientShipmentInstructions/clientShipmentInstructionsPage";
import WorkshopHomePage from "../authenticated/bepiService/workshop/workshopHome/workshopHomePage";
import WorkshopQuotePage from "../authenticated/bepiService/workshop/workshopQuote/workshopQuotePage";
import WorkshopDetailsPage from "../authenticated/bepiService/workshop/workshopDetails/workshopDetailsPage";
import WorkshopEquipamentsPage from "../authenticated/bepiService/workshop/workshopEquipaments/workshopEquipamentsPage";
import WorkshopEquipamentDetailsPage
    from "../authenticated/bepiService/workshop/workshopEquipamentDetails/workshopEquipamentDetailsPage";
import WorkshopEstimateRespondPage
    from "../authenticated/bepiService/workshop/workshopEstimateRespond/workshopEstimateRespondPage";
import WorkshopEquipamentAddPage
    from "../authenticated/bepiService/workshop/workshopEqupamentAdd/workshopEquipamentAddPage";
import WorkshopSearchPage from "../authenticated/bepiService/workshop/workshopSearch/workshopSearchPage";
import AdminEquipamentDetailsPage
    from "../authenticated/bepiService/admin/adminEquipamentDetails/adminEquipamentDetailsPage";
import AdminHomePage from "../authenticated/bepiService/admin/adminHome/adminHomePage";
import AdminSearchPage from "../authenticated/bepiService/admin/adminSearch/adminSearchPage";
import AdminEquipamentsPage from "../authenticated/bepiService/admin/adminEquipaments/adminEquipamentsPage";
import AdminShipmentInstructionsPage
    from "../authenticated/bepiService/admin/adminShipmentInstructions/adminShipmentInstructionsPage";
import AdminDetailsPage from "../authenticated/bepiService/admin/adminDetails/adminDetailsPage";
import AdminAddEquipPage from "../authenticated/bepiService/admin/adminAddEquip/adminAddEquipPage";
import AdminQuotePage from "../authenticated/bepiService/admin/adminQuote/adminQuotePage";
import AdminEstimateRespondPage
    from "../authenticated/bepiService/admin/adminEstimateRespondPage/adminEstimateRespondPage";
// DESATIVADO - import AdminAddCadUser from "../authenticated/bepiService/admin/adminAddCadUser/adminAddCadUser";

const trackingId = "GTM-MKH7HGJ"

ReactGA.initialize(trackingId)


export class App extends React.Component {
    state = {
        initialRoute: '/',
        loggedUser: { currentRole: null },
        currentLanguage: languages.pt,
        companyGroupStatus: CompanyGroupStatus.OK
    }

    componentDidMount = () => {
        ReactGA.pageview(window.location.pathname + window.location.search)

        // Resolve translations from the bundled `languages` module (never from a
        // localStorage snapshot of the whole object), so newly added translation
        // keys are never missing for users who previously picked a language.
        const savedLangCode = JSON.parse(localStorage.getItem("language"))
        const currentLanguage = (savedLangCode && languages[savedLangCode]) ? languages[savedLangCode] : languages.pt

        // Drop the legacy full-object snapshot if present.
        localStorage.removeItem("current-language")

        this.setState({ currentLanguage })

        LoggedUserService.getSessionLoggedUser().then(this.authenticate).catch(this.deauthenticate)
    }

    componentDidUpdate = () => ReactGA.pageview(window.location.pathname + window.location.search)

    authenticate = loggedUser => {
        const { initialRoute } = this.state

        CompanyGroupService.getStatus(loggedUser.companyGroup).then(response => this.setState({ companyGroupStatus: response }))

        if (initialRoute !== '/') {
            HistoryService.goto(initialRoute)
        }

        this.setState({ loggedUser, initialRoute: '/' })
    }

    deauthenticate = () => {
        AuthenticationService.deauthenticate()

        this.setState({ loggedUser: { currentRole: RoleConstant.ANONYMOUS } })

        switch (HistoryService.path()) {
            case '/register': break
            case '/password-reset': break
            case '/privacy-policy': break
            default: HistoryService.goto('/')
        }
    }

    updateLoggedUser = loggedUser => {
        this.setState({ loggedUser })
    }

    updateCompanyGroup = companyGroup => {
        const { loggedUser } = this.state

        LoggedUserService.getLoggedUser().then(loggedUser => {
            this.setState({ loggedUser })
        })

        this.setState({ loggedUser: { ...loggedUser, companyGroup } })
    }

    buildAnonymousRoutes = () => (
        <Switch>
            <Route exact path="/inspections-report" render={() => (<RedirectPage to="/" callback={() => this.setState({ initialRoute: '/report?view=inspections-report' })} />)} />
            <Route exact path="/register" render={() => (<RegisterUserPage currentLanguage={this.state.currentLanguage} />)} />
            <Route exact path="/password-reset" render={() => (<PasswordResetPage onPasswordReset={this.authenticate} currentLanguage={this.state.currentLanguage} />)} />
            <Route exact path="/active-environment" render={() => (<ActiveEnvironmentPage onActiveEnvironment={this.authenticate} currentLanguage={this.state.currentLanguage} />)} />
            <Route exact path="/privacy-policy" render={() => (<PrivacyPolicyPage />)} />
            <Route exact path="/plans" render={() => <PlanPage onAuthentication={this.authenticate} currentLanguage={this.state.currentLanguage} />} />
            <Route exact path="/" render={() => <LandpagePage onAuthentication={this.authenticate} currentLanguage={this.state.currentLanguage} />} />
            <Redirect push to="/" />
        </Switch>
    )

    buildMobcheckAdminRoutes = loggedUser => (
        <div style={{ display: 'flex', minHeight: '100vh' }}>
            <AppSidebar loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />
            <FlexColumnDiv style={{ flex: 1, minWidth: 0 }}>
            <Flex11Div>
                <Switch>
                    {/* Rotas BEPI - Cliente */}
                    <Route exact path="/bepi/client" render={() => (<ClientHomePage currentLanguage={this.state.currentLanguage} />)} />
                    {/* <Route exact path="/bepi/client/equipaments" render={() => (<ClientEquipamentsPage currentLanguage={this.state.currentLanguage} />)} /> */}
                    <Route exact path="/bepi/client/equipament/details/:id" render={() => (<ClientEquipamentDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/equipament/details" render={() => (<ClientEquipamentDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/quotations" render={() => (<ClientQuotationsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/quote" render={() => (<ClientQuotePage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/quote/details/:id" render={() => (<ClientQuoteDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/shipment/:id?" render={({ match }) => (<ClientShipmentInstructionsPage currentLanguage={this.state.currentLanguage} match={match} />)} />

                    {/* Rotas BEPI - Oficina */}
                    <Route exact path="/bepi/workshop" render={() => (<WorkshopHomePage currentLanguage={this.state.currentLanguage} />)} />
                    {/*<Route exact path="/bepi/workshop/quotations" render={() => (<WorkshopQuotationsPage currentLanguage={this.state.currentLanguage} />)} />*/}
                    <Route exact path="/bepi/workshop/quote" render={() => (<WorkshopQuotePage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/quote/details" render={() => (<WorkshopDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/equipaments" render={() => (<WorkshopEquipamentsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/equipament/details" render={() => (<WorkshopEquipamentDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/equipament/add" render={() => (<WorkshopEquipamentAddPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/estimate/respond" render={() => (<WorkshopEstimateRespondPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/search" render={() => (<WorkshopSearchPage currentLanguage={this.state.currentLanguage} />)} />

                    {/* Rotas BEPI - Admin */}
                    {/* DESATIVADO - Rota Cadastrar Usuário
                    <Route exact path="/bepi/admin/user/add" render={() => (<AdminAddCadUser currentLanguage={this.state.currentLanguage} />)} />
                    */}
                    <Route exact path="/bepi/admin" render={() => (<AdminHomePage currentLanguage={this.state.currentLanguage} />)} />
                    {/*<Route exact path="/bepi/admin/quotations" render={() => (<AdminQuotationsPage currentLanguage={this.state.currentLanguage} />)} />*/}
                    <Route exact path="/bepi/admin/quote" render={() => (<AdminQuotePage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/admin/quote/details" render={() => (<AdminDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/admin/equipaments" render={() => (<AdminEquipamentsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/admin/equipament/details/:id" render={() => (<AdminEquipamentDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/admin/equipament/details" render={() => (<AdminEquipamentDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/admin/equipament/add" render={() => (<AdminAddEquipPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/admin/estimate/respond" render={() => (<AdminEstimateRespondPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/admin/search" render={() => (<AdminSearchPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/admin/shipment" render={() => (<AdminShipmentInstructionsPage currentLanguage={this.state.currentLanguage} />)} />

                    {/* Rotas existentes do Mobcheck */}
                    <Route exact path="/inspections-report" render={() => (<RedirectPage to="/report?view=inspections-report" />)} />
                    <Route exact path="/logout" render={() => (<RedirectPage to="/" callback={this.deauthenticate} />)} />
                    <Route exact path="/inspections" render={() => (<EquipmentsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/maintenances" render={() => (<MaintenancesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/categories" render={() => (<CategoriesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/subcategories" render={() => (<InspectionTypesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/products" render={() => (<ProductsPage isAdmin={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags" render={() => (<TagsPage loggedUser={loggedUser} allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-replace" render={() => (<TagsReplacePage allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-qr-code" render={() => (<TagQrCodePage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/company-users" render={() => (<CompanyUsersPage isAdmin={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/companies" render={() => (<CompaniesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/company-groups" render={() => (<CompanyGroupsPage onUpdate={this.updateCompanyGroup} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/users" render={() => (<UsersPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/os" render={() => (<OsPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/create-os" render={() => (<CreateOSPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/profile" render={() => (<LoggedUserPage onUpdate={this.updateLoggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/change-password" render={() => (<ChangePasswordPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/config-system" render={() => (<ConfigSystemPage currentLanguage={this.state.currentLanguage} setCurrentLanguage={(lang) => this.setCurrentLanguage(lang)} />)} />
                    <Route exact path="/my-plan" render={() => (<MyPlanPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/buy-tag" render={() => (<BuyTagPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/video-lessons" render={() => (<VideoLessonsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/" render={() => (<DashboardPage currentLanguage={this.state.currentLanguage} />)} />
                    <Redirect push to="/" />
                </Switch>
            </Flex11Div>
            <Footer />
            </FlexColumnDiv>
        </div>
    )
    // buildMobcheckAdminRoutes = loggedUser => (
    //     <FlexColumnDiv style={{ minHeight: '100vh' }}>
    //         <Flex11Div>
    //             <Switch>
    //                 <Route exact path="/" render={() => (<ClientHomePage />)} />
    //                 <Route exact path="/equipaments" render={() => (<ClientEquipamentsPage />)} />
    //                 <Route exact path="/equipament/details" render={() => (<ClientEquipamentDetailsPage />)} />
    //                 <Route exact path="/quotations" render={() => (<ClientQuotationsPage />)} />
    //                 <Route exact path="/quote" render={() => (<ClientQuotePage />)} />
    //                 <Route exact path="/quote/details" render={() => (<ClientQuoteDetailsPage />)} />
    //                 <Route exact path="/shipment" render={() => (<ClientShipmentInstructionsPage />)} />

    //                 <Route exact path="/workshop/home" render={() => (<WorkshopHomePage />)} />
    //                 <Route exact path="/workshop/quotations" render={() => (<WorkshopQuotationsPage />)} />
    //                 <Route exact path="/workshop/quote" render={() => (<WorkshopQuotePage />)} />
    //                 <Route exact path="/workshop/quote/details" render={() => (<WorkshopDetailsPage />)} />
    //                 <Route exact path="/workshop/equipaments" render={() => (<WorkshopEquipamentsPage />)} />
    //                 <Route exact path="/workshop/equipament/details" render={() => (<WorkshopEquipamentDetailsPage />)} />
    //                 <Route exact path="/workshop/equipament/add" render={() => (<WorkshopEquipamentAddPage />)} />
    //                 <Route exact path="/workshop/estimate/respond" render={() => (<WorkshopEstimateRespondPage />)} />
    //                 <Route exact path="/workshop/search" render={() => (<WorkshopSearchPage />)} />

    //                 <Route exact path="/admin/home" render={() => (<AdminHomePage />)} />
    //                 <Route exact path="/admin/quotations" render={() => (<AdminQuotationsPage />)} />
    //                 <Route exact path="/admin/quote" render={() => (<AdminQuotePage />)} />
    //                 <Route exact path="/admin/quote/details" render={() => (<AdminDetailsPage />)} />
    //                 <Route exact path="/admin/equipaments" render={() => (<AdminEquipamentsPage />)} />
    //                 <Route exact path="/admin/equipament/details" render={() => (<AdminEquipamentDetailsPage />)} />
    //                 <Route exact path="/admin/equipament/add" render={() => (<AdminAddEquipPage />)} />
    //                 <Route exact path="/admin/search" render={() => (<AdminSearchPage />)} />
    //                 <Route exact path="/admin/shipment" render={() => (<AdminShipmentInstructionsPage />)} />
    //             </Switch>
    //         </Flex11Div>
    //     </FlexColumnDiv>
    // )

    buildCompanyGroupAdminRoutes = loggedUser => (
        <div style={{ display: 'flex', minHeight: '100vh' }}>
            <AppSidebar loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />
            <FlexColumnDiv style={{ flex: 1, minWidth: 0 }}>
            <Flex11Div>
                <Switch>
                    <Route exact path="/inspections-report" render={() => (<RedirectPage to="/report?view=inspections-report" />)} />
                    <Route exact path="/logout" render={() => (<RedirectPage to="/" callback={this.deauthenticate} />)} />
                    <Route exact path="/inspections" render={() => (<EquipmentsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/maintenances" render={() => (<MaintenancesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/categories" render={() => (<CategoriesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/subcategories" render={() => (<InspectionTypesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/products" render={() => (<ProductsPage isAdmin={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags" render={() => (<TagsPage loggedUser={loggedUser} allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-replace" render={() => (<TagsReplacePage allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-qr-code" render={() => (<TagQrCodePage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/company-users" render={() => (<CompanyUsersPage isAdmin={false} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/user-companies" render={() => (<UserCompanyGroupPage onUpdate={this.updateCompanyGroup} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/companies" render={() => (<CompaniesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/os" render={() => (<OsPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/create-os" render={() => (<CreateOSPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/profile" render={() => (<LoggedUserPage onUpdate={this.updateLoggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/change-password" render={() => (<ChangePasswordPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/config-system" render={() => (<ConfigSystemPage currentLanguage={this.state.currentLanguage} setCurrentLanguage={(lang) => this.setCurrentLanguage(lang)} />)} />
                    <Route exact path="/my-plan" render={() => (<MyPlanPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/buy-tag" render={() => (<BuyTagPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/video-lessons" render={() => (<VideoLessonsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/" render={() => (<DashboardPage currentLanguage={this.state.currentLanguage} />)} />
                    <Redirect push to="/" />
                </Switch>
            </Flex11Div>
            <Footer />
            </FlexColumnDiv>
        </div>
    )

    buildCompanyAdminRoutes = loggedUser => (
        <div style={{ display: 'flex', minHeight: '100vh' }}>
            <AppSidebar loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />
            <FlexColumnDiv style={{ flex: 1, minWidth: 0 }}>
            <Flex11Div>
                <Switch>
                    <Route exact path="/inspections-report" render={() => (<RedirectPage to="/report?view=inspections-report" />)} />
                    <Route exact path="/logout" render={() => (<RedirectPage to="/" callback={this.deauthenticate} />)} />
                    <Route exact path="/inspections" render={() => (<EquipmentsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/maintenances" render={() => (<MaintenancesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/categories" render={() => (<CategoriesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/subcategories" render={() => (<InspectionTypesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/products" render={() => (<ProductsPage isAdmin={false} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags" render={() => (<TagsPage loggedUser={loggedUser} allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-replace" render={() => (<TagsReplacePage allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-qr-code" render={() => (<TagQrCodePage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/company-users" render={() => (<CompanyUsersPage isAdmin={false} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/os" render={() => (<OsPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/create-os" render={() => (<CreateOSPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/profile" render={() => (<LoggedUserPage onUpdate={this.updateLoggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/change-password" render={() => (<ChangePasswordPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/config-system" render={() => (<ConfigSystemPage currentLanguage={this.state.currentLanguage} setCurrentLanguage={(lang) => this.setCurrentLanguage(lang)} />)} />
                    <Route exact path="/my-plan" render={() => (<MyPlanPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/buy-tag" render={() => (<BuyTagPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/video-lessons" render={() => (<VideoLessonsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/" render={() => (<DashboardPage currentLanguage={this.state.currentLanguage} />)} />
                    <Redirect push to="/" />
                </Switch>
            </Flex11Div>
            <Footer />
            </FlexColumnDiv>
        </div>
    )

    buildServiceWorkshopRoutes = loggedUser => (
        <div style={{ display: 'flex', minHeight: '100vh' }}>
            <AppSidebar loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />
            <FlexColumnDiv style={{ flex: 1, minWidth: 0 }}>
            <Flex11Div>
                <Switch>
                    {/* Rotas BEPI - Oficina */}
                    <Route exact path="/bepi/workshop" render={() => (<WorkshopHomePage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/quote" render={() => (<WorkshopQuotePage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/quote/details" render={() => (<WorkshopDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/equipaments" render={() => (<WorkshopEquipamentsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/equipament/details" render={() => (<WorkshopEquipamentDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/equipament/add" render={() => (<WorkshopEquipamentAddPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/estimate/respond" render={() => (<WorkshopEstimateRespondPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/workshop/search" render={() => (<WorkshopSearchPage currentLanguage={this.state.currentLanguage} />)} />

                    <Route exact path="/inspections-report" render={() => (<RedirectPage to="/report?view=inspections-report" />)} />
                    <Route exact path="/logout" render={() => (<RedirectPage to="/" callback={this.deauthenticate} />)} />
                    <Route exact path="/inspections" render={() => (<EquipmentsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/maintenances" render={() => (<MaintenancesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/categories" render={() => (<CategoriesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/subcategories" render={() => (<InspectionTypesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/products" render={() => (<ProductsPage isAdmin={false} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags" render={() => (<TagsPage loggedUser={loggedUser} allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-replace" render={() => (<TagsReplacePage allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-qr-code" render={() => (<TagQrCodePage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/company-users" render={() => (<CompanyUsersPage isAdmin={false} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/os" render={() => (<OsPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/create-os" render={() => (<CreateOSPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/profile" render={() => (<LoggedUserPage onUpdate={this.updateLoggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/change-password" render={() => (<ChangePasswordPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/config-system" render={() => (<ConfigSystemPage currentLanguage={this.state.currentLanguage} setCurrentLanguage={(lang) => this.setCurrentLanguage(lang)} />)} />
                    <Route exact path="/my-plan" render={() => (<MyPlanPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/buy-tag" render={() => (<BuyTagPage loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/video-lessons" render={() => (<VideoLessonsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/" render={() => (<DashboardPage currentLanguage={this.state.currentLanguage} />)} />
                    <Redirect push to="/" />
                </Switch>
            </Flex11Div>
            <Footer />
            </FlexColumnDiv>
        </div>
    )

    buildOperatorRoutes = loggedUser => (
        <div style={{ display: 'flex', minHeight: '100vh' }}>
            <AppSidebar loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />
            <FlexColumnDiv style={{ flex: 1, minWidth: 0 }}>
            <Flex11Div>
                <Switch>
                    <Route exact path="/inspections-report" render={() => (<RedirectPage to="/report?view=inspections-report" />)} />
                    <Route exact path="/logout" render={() => (<RedirectPage to="/" callback={this.deauthenticate} />)} />
                    <Route exact path="/inspections" render={() => (<EquipmentsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/maintenances" render={() => (<MaintenancesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags" render={() => (<TagsPage allowTagToggle={false} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-replace" render={() => (<TagsReplacePage allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/profile" render={() => (<LoggedUserPage onUpdate={this.updateLoggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/change-password" render={() => (<ChangePasswordPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/config-system" render={() => (<ConfigSystemPage />)} currentLanguage={this.state.currentLanguage} setCurrentLanguage={(lang) => this.setCurrentLanguage(lang)} />
                    <Route exact path="/" render={() => (<DashboardCommonPage currentLanguage={this.state.currentLanguage} />)} />
                    <Redirect push to="/" />
                </Switch>
            </Flex11Div>
            <Footer />
            </FlexColumnDiv>
        </div>
    )

    buildServiceClientRoutes = loggedUser => (
        <div style={{ display: 'flex', minHeight: '100vh' }}>
            <AppSidebar loggedUser={loggedUser} currentLanguage={this.state.currentLanguage} />
            <FlexColumnDiv style={{ flex: 1, minWidth: 0 }}>
            <Flex11Div>
                <Switch>
                    {/* Rotas BEPI - Cliente */}
                    <Route exact path="/bepi/client" render={() => (<ClientHomePage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/equipament/details/:id" render={() => (<ClientEquipamentDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/equipament/details" render={() => (<ClientEquipamentDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/quotations" render={() => (<ClientQuotationsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/quote" render={() => (<ClientQuotePage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/quote/details/:id" render={() => (<ClientQuoteDetailsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/bepi/client/shipment/:id?" render={({ match }) => (<ClientShipmentInstructionsPage currentLanguage={this.state.currentLanguage} match={match} />)} />

                    <Route exact path="/inspections-report" render={() => (<RedirectPage to="/report?view=inspections-report" />)} />
                    <Route exact path="/logout" render={() => (<RedirectPage to="/" callback={this.deauthenticate} />)} />
                    <Route exact path="/inspections" render={() => (<EquipmentsPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/maintenances" render={() => (<MaintenancesPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags" render={() => (<TagsPage allowTagToggle={false} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/tags-replace" render={() => (<TagsReplacePage allowTagToggle={true} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/profile" render={() => (<LoggedUserPage onUpdate={this.updateLoggedUser} currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/change-password" render={() => (<ChangePasswordPage currentLanguage={this.state.currentLanguage} />)} />
                    <Route exact path="/config-system" render={() => (<ConfigSystemPage />)} currentLanguage={this.state.currentLanguage} setCurrentLanguage={(lang) => this.setCurrentLanguage(lang)} />
                    <Route exact path="/" render={() => (<DashboardCommonPage currentLanguage={this.state.currentLanguage} />)} />
                    <Redirect push to="/" />
                </Switch>
            </Flex11Div>
            <Footer />
            </FlexColumnDiv>
        </div>
    )

    buildLoading = () => (
        <LoadingScreen
            loading={true}
            bgColor='#000000'
            spinnerColor='#FFFFFF'
            textColor='#FFFFFF'
            logoSrc={LOGO}
        >
            <span />
        </LoadingScreen>
    )

    setCurrentLanguage(lang) {
        // Persist only the language code; translations always come from `languages`.
        localStorage.setItem("language", JSON.stringify(lang))
        this.setState({ currentLanguage: languages[lang] })
    }

    isValidCurrentLanguage = currentLanguage => {
        if (!currentLanguage || typeof currentLanguage !== 'object') return false;

        const mustBeStringKeys = ['dashboard', 'settings', 'logout', 'profile'];
        const hasLegacyKeys = mustBeStringKeys.every(key => typeof currentLanguage[key] === 'string');
        const hasBepiService = currentLanguage.bepiService !== undefined;

        return hasLegacyKeys && hasBepiService;
    }

    showPendingPayment = () => {
        const MySwal = withReactContent(Swal)

        MySwal.fire({
            position: 'center',
            icon: 'warning',
            html: 'Você possui pagamentos pendentes. Favor acessar o menu "Meu Plano" e verificar a situação.',
            showConfirmButton: false,
            allowOutsideClick: false
        })
    }

    render() {
        const { loggedUser, companyGroupStatus } = this.state

        switch (loggedUser.currentRole) {
            case RoleConstant.MOBCHECK_ADMIN:
            case RoleConstant.SERVICE_ADMIN:
                return this.buildMobcheckAdminRoutes(loggedUser)
            case RoleConstant.COMPANY_GROUP_ADMIN:
                if (companyGroupStatus === CompanyGroupStatus.PENDING_PAYMENT && HistoryService.path() !== '/my-plan') {
                    this.showPendingPayment()
                }

                return this.buildCompanyGroupAdminRoutes(loggedUser)
            case RoleConstant.COMPANY_ADMIN:
                if (companyGroupStatus === CompanyGroupStatus.PENDING_PAYMENT && HistoryService.path() !== '/my-plan') {
                    this.showPendingPayment()
                }

                return this.buildCompanyAdminRoutes(loggedUser)
            case RoleConstant.SERVICE_WORKSHOP:
                if (companyGroupStatus === CompanyGroupStatus.PENDING_PAYMENT && HistoryService.path() !== '/my-plan') {
                    this.showPendingPayment()
                }

                return this.buildServiceWorkshopRoutes(loggedUser)
            case RoleConstant.COMPANY_OPERATOR:
                if (companyGroupStatus === CompanyGroupStatus.PENDING_PAYMENT && HistoryService.path() !== '/my-plan') {
                    this.showPendingPayment()
                }

                return this.buildOperatorRoutes(loggedUser)
            case RoleConstant.SERVICE_CLIENT:
                if (companyGroupStatus === CompanyGroupStatus.PENDING_PAYMENT && HistoryService.path() !== '/my-plan') {
                    this.showPendingPayment()
                }

                return this.buildServiceClientRoutes(loggedUser)
            case RoleConstant.ANONYMOUS:
                return this.buildAnonymousRoutes()
            default: return this.buildLoading()
        }

    }

}


